

[
    "identity/roles/list",
    "identity/users/list",
    "identity/companyaccessrestrictions/list",
    "identity/groups/list",
    "corepatterns/companies/list",
    "corepatterns/currencies/list",
    "corepatterns/countries/list",
    "corepatterns/regions/list",
    "corepatterns/postalzones/list",
    "corepatterns/units/list",
    "corepatterns/unitdimensions/list",
    "corepatterns/cultures/list",
    "corepatterns/sequences/list",
    "corepatterns/contacts/list",
    "corepatterns/contacttypes/list",
    "corepatterns/contactgroups/list",
    "corepatterns/fiscaltimezones/list",
    "corepatterns/importdatatemplates/list",
    "corepatterns/schemaentities/list",
    "corepatterns/assignments/list",
    "corepatterns/addresses/list",
    "corepatterns/backgroundoperations/list",
    "corepatterns/schemabusinessrules/list",
    "operations/notifications/list",
    "operations/emailtemplates/list",
    "assetmanagementcore/locationfunctions/list",
    "assetmanagementcore/locations/list",
    "assetmanagementcore/criticalities/list",
    "assetmanagementcore/equipmentitems/list",
    "assetmanagementcore/routes/list",
    "assetmanagementcore/meters/list",
    "assetmanagementcore/spareparts/list",
    "businesscore/series/list",
    "businesscore/brands/list",
    "businesscore/exchangeratesdocuments/list",
    "businesscore/brandmodels/list",
    "businesscore/parties/list",
    "businesscore/families/list",
    "businesscore/parts/list",
    "businesscore/pricelists/list",
    "businesscore/dimensions/list",
    "businesscore/partaccounttypes/list",
    "businesscore/partyaccounttypes/list",
    "businesscore/customergroups/list",
    "businesscore/suppliergroups/list",
    "businesscore/dimensionvalues/list",
    "businesscore/vkentittystatetransitionhistories/list",
    "businesscore/vkschemaentitystates/list",
    "businesscore/dimensionsets/list",
    "businesscore/purchasesparts/list",
    "businesscore/customerparties/list",
    "businesscore/supplierparties/list",
    "businesscore/statejustifications/list",
    "businesscore/statejustificationstypes/list",
    "businesscore/characteristictypes/list",
    "businesscore/characteristics/list",
    "businesscore/calendareventkinds/list",
    "businesscore/workcalendars/list",
    "businesscore/worktimeschedules/list",
    "businesscore/batchprocessingstatuses/list",
    "requests/requestreasons/list",
    "requests/requesttypes/list",
    "requests/requests/list",
    "requests/allrequests/list",
    "requests/requeststatetransitions/list",
    "maintenancecore/maintenanceplantypes/list",
    "maintenancecore/maintenanceplans/list",
    "maintenancecore/prioritylevels/list",
    "maintenancecore/workordertypes/list",
    "maintenancecore/activities/list",
    "maintenancecore/workorderstates/list",
    "maintenancecore/requeststates/list",
    "maintenancecore/misccosts/list",
    "maintenancecore/verifications/list",
    "maintenancecore/misccoststypes/list",
    "maintenancecore/verificationtypes/list",
    "maintenancecore/failureactions/list",
    "maintenancecore/failurecauses/list",
    "maintenancecore/failuresymptoms/list",
    "maintenancecore/familyfailuretypifications/list",
    "maintenancecore/operatingstates/list",
    "maintenancecore/maintenancenotifications/list",
    "workshopscore/employees/list",
    "workshopscore/expertises/list",
    "workshopscore/tiers/list",
    "workshopscore/workshops/list",
    "workshopscore/schedulinggroups/list",
    "workshopscore/schedulinglaborcosts/list",
    "workshopscore/geolocationhistories/list",
    "workshopscore/consents/list",
    "settings/accesslevels/list",
    "settings/deletedentities/list",
    "settings/importdatatemplates/list",
    "settings/labelconfigurations/list",
    "settings/analyticsdashboards/list",
    "settings/assetrestrictions/list",
    "settings/mobilereports/list",
    "settings/assetgroups/list",
    "settings/companysettings/list",
    "settings/warehouserestrictions/list",
    "settings/customtags/list",
    "settings/inactiverecords/list",
    "maintenance/workorders/list",
    "maintenance/workorderrequests/list",
    "maintenance/workorderreportmisccosts/list",
    "maintenance/workorderreportlabors/list",
    "maintenance/workordertaskverifications/list",
    "maintenance/workorderreportconsumptions/list",
    "maintenance/wotaskselections/list",
    "maintenance/womptaskselections/list",
    "maintenance/workorderassignments/list",
    "maintenance/failures/list",
    "maintenance/preventivemaintenances/list",
    "maintenance/preventivemaintenanceevents/list",
    "maintenance/previewpreventiveevents/list",
    "maintenance/operationalreports/list",
    "maintenance/vktransitionchanges/list",
    "maintenance/workorderassignmentsbyemployees/list",
    "maintenance/workordertotalcosts/list",
    "maintenance/preventivemaintfileimports/list",
    "maintenance/workordertaskverificationsdetailexplorations/list",
    "maintenance/workordertraceabilities/list",
    "maintenance/workordertraceabilitiesstars/list",
    "maintenance/expectedprevmaintparts/list",
    "maintenance/expectedprevmaintlabors/list",
    "maintenance/workorderstatetransitions/list",
    "maintenance/workorderdetailtotalcosts/list",
    "maintenance/preventivemaintenancestatetransitions/list",
    "inventorymanagement/adjustmentreasons/list",
    "inventorymanagement/stocktransferorders/list",
    "inventorymanagement/partadjustments/list",
    "inventorymanagement/partentries/list",
    "inventorymanagement/partissues/list",
    "inventorymanagement/explorerpartissues/list",
    "inventorycore/warehouses/list",
    "inventorycore/inventorypostings/list",
    "inventorycore/stockfailures/list",
    "inventorycore/stocksurplus/list",
    "inventorycore/partsstatements/list",
    "inventorycore/partsubtypes/list",
    "inventorycore/inventorysetups/list",
    "inventorycore/inventoryparts/list",
    "inventorycore/documenttypes/list",
    "inventorycore/inventorypartwarehouses/list",
    "assetmanagement/workersconfigurations/list",
    "assetmanagement/assetsindicators/list",
    "assetmanagement/locationparentlocationhistories/list",
    "assetmanagement/assetlocationhistories/list",
    "assetmanagement/downanduptimehistories/list",
    "assetmanagement/downtimehistorytimes/list",
    "assetmanagement/assetinactivationhistorics/list",
    "assetmanagement/monitorings/list",
    "assetmanagement/metervalues/list",
    "assetmanagement/monitoringvalues/list",
    "assetmanagement/wometerreadings/list",
    "assetmanagement/womonitoringvalues/list",
    "assetmanagement/locationhistories/list",
    "assetmanagement/parentequipmentchanges/list",
    "assetmanagement/parentequipmentchangeshistories/list",
    "assetmanagement/equipmentreceptions/list",
    "integration/integratorpipelines/list",
    "integration/auditpipelines/list",
    "integration/auditpipelinedetails/list",
    "integration/integrationerrors/list",
    "integration/pipelines/list",
    "integration/integrationconfigs/list",
    "integration/pipelinesettings/list",
    "integration/integrationstatuses/list",
    "integration/integrationalerts/list",
    "requisitionscore/requisitiontypes/list",
    "requisitionscore/requisitionstates/list",
    "requisitions/requisitions/list",
    "contractscore/contracttypes/list",
    "contractscore/contractstates/list",
    "contracts/contracts/list",
    "reporting/templates/list",
    "reporting/templateentitygroups/list",
    "reporting/customreports/list"
]
